import React from "react";
import { ErrorScreen } from "./ErrorScreen";

class ErrorBoundary extends React.Component {
    constructor(p) {
      super(p);
      this.state = {
        err: null,
      };
    }
    static getDerivedStateFromError(err) {
      return {
        err,
      };
    }
    componentDidCatch(err, info) {
      console.error("Estatebook render error:", err, info);
    }
    render() {
      return this.state.err ? (
        <ErrorScreen
          title="Something broke"
          msg={this.state.err.message || String(this.state.err)}
        />
      ) : (
        this.props.children
      );
    }
  }

export { ErrorBoundary };
